

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.-hddgj8G.js","_app/immutable/chunks/scheduler.DHUbek42.js","_app/immutable/chunks/index.ClBRh6_e.js","_app/immutable/chunks/stores.Bn98H8tp.js","_app/immutable/chunks/entry.CQz9NNcx.js","_app/immutable/chunks/index.gpef7426.js"];
export const stylesheets = [];
export const fonts = [];
